import Spacer from '@berlitz/spacer'
import LockUnlock1 from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/11-Lock-Unlock/LockUnlock1'
import InformationCircle from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/14-Alerts/InformationCircle'
import LearningPathUnit from '@classes/LearningPathUnit'
import Button from '@components/Button'
import { Card, CardContent, CardHeader, Float, Icon, IconCircle, Subtitle, Tag, Title } from '@components/LPCard/Common'
import Router from 'next/router'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TopTag } from '../Lesson/style'
import { Description, SubContainer } from './style'

interface IPUnlocked {
  Unit: LearningPathUnit
}
export const Unlocked: React.FC<IPUnlocked> = ({ Unit }) => (
  <Card type="speakingPanel" withHalo active>
    <CardContent isElective={Unit?.IsFromElective}>
      <CardHeader>
        {Unit?.IsFromElective && (
          <TopTag color="info100">
            <FormattedMessage id="Elective" defaultMessage="Elective" />
          </TopTag>
        )}
        <Icon color="white">
          <IconCircle color="info100" />
          <LockUnlock1 />
        </Icon>
      </CardHeader>

      <Spacer size="md" />

      <Tag>
        <FormattedMessage id="Unlocked" />
      </Tag>

      <Spacer size="xs" />

      <Title color="info100">{Unit?.LCSTitle}</Title>

      <Spacer size="sm" />

      <Subtitle>
        <Float>
          <Button
            color="success"
            narrow
            onClick={() =>
              Router.push(
                `/scheduling/single-lesson?programid=${Unit?.StudentProgram?.ProgramId}&unitId=${Unit?.Id}&LPId=${Unit?.LPId}`
              )
            }
          >
            <FormattedMessage id="Book" />
          </Button>
        </Float>
      </Subtitle>

      <Spacer size="md" />

      <SubContainer color="info30">
        <InformationCircle />
        <Description color="text00">
          <FormattedMessage id="Practice what you've learnt with an instructor, online via video. (approx. 30 minutes)" />
        </Description>
      </SubContainer>
      <Spacer size="xs" />
    </CardContent>
  </Card>
)

export default Unlocked
